import { EntityId } from "@jackfruit/common"
import React from "react"
import { useCart } from "~/hooks/useCart"
import { useLineItem } from "~/hooks/useLineItem"
import { getQuantitySelectorConfig } from "./helpers"
import LineItemPreviewQuantitySelectorBasic from "./LineItemPreviewQuantitySelectorBasic"
import LineItemPreviewQuantitySelectorWithSuggestions from "./LineItemPreviewQuantitySelectorWithSuggestions"

interface Props {
  lineItemId: EntityId
  lineItemQuantityLimit: number
}

const LineItemPreviewQuantitySelector: React.FC<Props> = props => {
  const { cart } = useCart()
  const { fulfillment } = cart
  const { lineItemId } = props
  const { product } = useLineItem(lineItemId)

  const quantitySelectorConfig = getQuantitySelectorConfig({
    product,
    fulfillment,
  })

  switch (quantitySelectorConfig.type) {
    case "withSuggestions":
      return <LineItemPreviewQuantitySelectorWithSuggestions {...props} />
    case "basic":
    default:
      return <LineItemPreviewQuantitySelectorBasic {...props} />
  }
}

export default LineItemPreviewQuantitySelector
